import React from 'react';
import { cn } from '../../lib/utils';

const Label = React.forwardRef(({
  className,
  ...props
}, ref) => {
  const labelClasses = cn(
    'text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
    className
  );

  return (
    <label
      ref={ref}
      className={labelClasses}
      {...props}
    />
  );
});

Label.displayName = 'Label';

export default Label;
